export default __webpack_public_path__ + "static/NeffSans-Regular-27270963197ece2e2fe5dc7ff2dd78ce.ttf";